/* Redux-Toolkit */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchTerm: "",
};

export const searchTermSlice = createSlice({
  name: "searchTerm",
  initialState,
  reducers: {
    setSearchTerm: (state, action) => {
      console.log("setSearchTerm", action.payload);
      state.searchTerm = action.payload;
    },
  },
});

/* Actions */
export const { setSearchTerm } = searchTermSlice.actions;

/* Reducer */
export default searchTermSlice.reducer;
